
import React, { RefObject } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { SendHorizonal } from "lucide-react";
import { cn } from "@/lib/utils";

interface ChatInputProps {
  message: string;
  setMessage: (message: string) => void;
  handleSendMessage: (e?: React.FormEvent) => void;
  isLoading: boolean;
  handleKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  inputRef?: RefObject<HTMLTextAreaElement>;
}

const ChatInput: React.FC<ChatInputProps> = ({
  message,
  setMessage,
  handleSendMessage,
  isLoading,
  handleKeyDown,
  inputRef,
}) => {
  return (
    <form 
      onSubmit={handleSendMessage} 
      className="border-t border-gray-200 dark:border-gray-700 p-2 flex items-end gap-2"
    >
      <Textarea
        ref={inputRef}
        className={cn(
          "flex-1 resize-none min-h-[60px] max-h-24",
          "focus:ring-2 focus:ring-purple-500 dark:focus:ring-purple-400",
          "transition-all duration-200 ease-in-out"
        )}
        placeholder="Type your question..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isLoading}
        rows={1}
      />
      <Button 
        type="submit" 
        disabled={isLoading || !message.trim()}
        className="bg-purple-600 hover:bg-purple-700 text-white h-10 w-10 rounded-full p-0 flex-shrink-0"
      >
        <SendHorizonal size={18} />
      </Button>
    </form>
  );
};

export default ChatInput;
